import { z } from 'zod';

const InputDef = z.object({
  key: z.string().min(1),
  label: z.string().min(1),
  type: z.enum([
    'text',
    'number',
    'money',
    'percent',
    'select',
    'geo',
    'property_type',
    'timeline',
  ]),
  required: z.boolean().optional(),
  options: z.array(z.object({ value: z.string(), label: z.string() })).optional(),
  default: z.unknown().optional(),
});

export const CalculatorConfig = z.object({
  inputs: z.array(InputDef).min(1),
  formula: z.string().min(1),
  outputFormat: z.enum(['money', 'percent', 'number', 'text']).optional(),
});
export type CalculatorConfig = z.infer<typeof CalculatorConfig>;

export const ComparatorConfig = z.object({
  options: z
    .array(
      z.object({
        id: z.string().min(1),
        label: z.string().min(1),
        attrs: z.record(z.unknown()).optional(),
      }),
    )
    .min(2),
  criteria: z.array(z.string()).default([]),
});
export type ComparatorConfig = z.infer<typeof ComparatorConfig>;

export const AnalyzerConfig = z.object({
  promptTemplate: z.string().min(1),
  inputs: z.array(InputDef).optional(),
  llm: z
    .enum(['claude-opus-4-7', 'claude-sonnet-4-6', 'claude-haiku-4-5'])
    .default('claude-sonnet-4-6'),
});
export type AnalyzerConfig = z.infer<typeof AnalyzerConfig>;

export const TrackerConfig = z.object({
  metrics: z.array(z.string().min(1)).min(1),
  cadence: z.enum(['daily', 'weekly', 'monthly']).default('weekly'),
});
export type TrackerConfig = z.infer<typeof TrackerConfig>;
